export const decisioningStudioLiftDecomposition =
  "/decisioning_studio_agents/:app_group_id/:dsa_id/insights/lift_decomposition" as const;
